(() => {
  if (window.solanaCartDrawerCustomLoaded) return;
  window.solanaCartDrawerCustomLoaded = true;

  let keepCartDrawerOpen = false;
  let keepCartDrawerOpener = null;

  function requestKeepCartDrawerOpen(opener = null) {
    keepCartDrawerOpen = true;
    keepCartDrawerOpener = opener;
  }

  function openCartDrawerAfterRefresh() {
    if (!keepCartDrawerOpen) return;
    requestAnimationFrame(() => {
      const drawer = document.querySelector('.js-cart-drawer');
      if (!drawer) return;
      if (!drawer.hasAttribute('open') && typeof drawer.open === 'function') drawer.open(keepCartDrawerOpener);
      keepCartDrawerOpen = false;
      keepCartDrawerOpener = null;
    });
  }

  function markItemRemoving(item) {
    if (!item || item.classList.contains('is-removing')) return;
    item.style.maxHeight = `${item.offsetHeight}px`;
    requestAnimationFrame(() => item.classList.add('is-removing'));
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function priceToCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'string') {
      const n = parseFloat(value.replace(/[^0-9.]/g, '')) || 0;
      return value.includes('.') ? Math.round(n * 100) : Math.round(n);
    }
    return Number(value) || 0;
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  }

  function getProductImage(product) {
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image?.src) return product.featured_image.src;
    if (product.images?.[0]?.src) return product.images[0].src;
    if (typeof product.images?.[0] === 'string') return product.images[0];
    return '';
  }

  function getVariant(product) {
    return product.variants?.find((v) => v.available) || product.variants?.[0] || null;
  }

  function getProductUrl(product) {
    if (product.url) return product.url;
    if (product.handle) return `${window.Shopify?.routes?.root || '/'}products/${product.handle}`;
    return '#';
  }

  function renderAutoRecommendation(product) {
    const variant = getVariant(product);
    if (!variant?.id) return '';
    const price = priceToCents(variant.price ?? product.price);
    const compareAtPrice = priceToCents(variant.compare_at_price ?? product.compare_at_price);
    const image = getProductImage(product);
    return `
      <article class="solana-cross-sell-row">
        <div class="solana-cross-sell-row__image">${image ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}" loading="lazy" decoding="async">` : ''}</div>
        <div class="solana-cross-sell-row__info">
          <div class="solana-cross-sell-row__title">${escapeHTML(product.title)}</div>
          <div class="solana-cross-sell-row__prices">
            ${compareAtPrice > price ? `<span class="solana-cross-sell-row__compare">${formatMoney(compareAtPrice)}</span>` : ''}
            <span class="solana-cross-sell-row__price">${formatMoney(price)}</span>
          </div>
        </div>
        <button type="button" class="solana-cross-sell-row__button" data-solana-quick-add data-variant-id="${escapeHTML(variant.id)}" ${variant.available === false ? 'disabled' : ''}>${variant.available === false ? 'SOLD OUT' : 'ADD'}</button>
      </article>`;
  }

  async function initAutomaticRecommendations() {
    const section = document.querySelector('[data-solana-auto-recommendations="true"]');
    const row = section?.querySelector('.solana-cross-sells__list');
    const productId = section?.dataset.productId;
    if (!section || !row || !productId || section.dataset.loadedFor === productId) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=6&intent=related`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const products = (await response.json()).products || [];
      if (!products.length) return;
      row.innerHTML = products.map(renderAutoRecommendation).join('');
      section.dataset.loadedFor = productId;
    } catch (e) {}
  }

  function renderEmptyProduct(product) {
    const variant = getVariant(product);
    if (!variant) return '';
    const image = getProductImage(product);
    const price = priceToCents(variant.price ?? product.price);
    const compareAtPrice = priceToCents(variant.compare_at_price ?? product.compare_at_price);
    return `
      <a class="solana-empty-card" href="${escapeHTML(getProductUrl(product))}">
        ${image ? `<img class="solana-empty-card__image" src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}" loading="lazy" decoding="async">` : '<span class="solana-empty-card__image"></span>'}
        <div class="solana-empty-card__body">
          <div class="solana-empty-card__title">${escapeHTML(product.title)}</div>
          <div class="solana-empty-card__prices">
            <span class="solana-empty-card__price">From ${formatMoney(price)}</span>
            ${compareAtPrice > price ? `<span class="solana-empty-card__compare">${formatMoney(compareAtPrice)}</span>` : ''}
          </div>
        </div>
      </a>`;
  }

  async function fetchProductsFrom(url) {
    try {
      const r = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!r.ok) return [];
      return (await r.json()).products || [];
    } catch (e) { return []; }
  }

  async function initEmptyProducts() {
    const section = document.querySelector('[data-solana-empty-products]');
    const grid = section?.querySelector('[data-solana-empty-products-grid]');
    if (!section || !grid || section.dataset.loaded === 'true') return;
    if (grid.children.length) { section.dataset.loaded = 'true'; return; }
    const root = window.Shopify?.routes?.root || '/';
    const handle = section.dataset.emptyCollectionHandle || 'best-sellers';
    let products = await fetchProductsFrom(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=4`);
    if (!products.length && handle !== 'best-sellers') products = await fetchProductsFrom(`${root}collections/best-sellers/products.json?limit=4`);
    if (!products.length) products = await fetchProductsFrom(`${root}collections/all/products.json?limit=4`);
    grid.innerHTML = products.slice(0, 4).map(renderEmptyProduct).join('');
    section.dataset.loaded = 'true';
  }

  function refreshCartDrawer() {
    const cartForm = document.querySelector('.js-cart-drawer cart-form');
    if (cartForm && typeof cartForm.refresh === 'function') cartForm.refresh();
    else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('.js-cart-drawer .js-close-drawer');
    if (closeButton) {
      keepCartDrawerOpen = false;
      keepCartDrawerOpener = null;
      const drawer = closeButton.closest('cart-drawer');
      if (drawer && typeof drawer.close === 'function') { event.preventDefault(); event.stopPropagation(); drawer.close(); }
      return;
    }
    const removeLink = event.target.closest('.js-cart-drawer .cart-item__remove');
    const quantityDown = event.target.closest('.js-cart-drawer .quantity-down');
    if (removeLink) { markItemRemoving(removeLink.closest('.cart-item')); return; }
    if (quantityDown) {
      const item = quantityDown.closest('.cart-item');
      const input = item?.querySelector('.cart-item__quantity-input');
      if (input && parseInt(input.value, 10) <= 1) markItemRemoving(item);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.js-cart-drawer .cart-item__quantity-input');
    if (!input) return;
    if (parseInt(input.value, 10) <= 0) markItemRemoving(input.closest('.cart-item'));
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.solana-gift-card__button, .solana-cross-sell-row__button');
    if (!button || button.matches('[data-solana-quick-add]')) return;
    button.dataset.solanaOriginalText = button.textContent;
    setTimeout(() => {
      if (!button.isConnected) return;
      const orig = button.dataset.solanaOriginalText || 'ADD';
      button.classList.add('is-added');
      button.textContent = button.classList.contains('solana-gift-card__button') ? '✓ Added' : '✓';
      setTimeout(() => { if (!button.isConnected) return; button.classList.remove('is-added'); button.textContent = orig; }, 1500);
    }, 250);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.js-cart-drawer .js-product-form');
    if (!form) return;
    requestKeepCartDrawerOpen(form.querySelector('[name="add"]') || form);
  }, true);

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-solana-quick-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.classList.contains('is-loading')) return;
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    const originalText = button.textContent;
    requestKeepCartDrawerOpen(button);
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding...';
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      const cartAddUrl = window.theme?.routes?.cartAdd || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
      const response = await fetch(cartAddUrl, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add item');
      refreshCartDrawer();
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id || variantId } }));
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = '✓';
      setTimeout(() => { if (!button.isConnected) return; button.classList.remove('is-added'); button.disabled = false; button.textContent = originalText; }, 1500);
    } catch (e) {
      button.classList.remove('is-loading');
      button.disabled = false;
      button.textContent = originalText;
      document.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: e.message } }));
    }
  });

 // ── Title + Price layout ─────────────────────────────────────────────────────
// Left col: Judge.me rating + trust badge + title
// Right col: SAVE badge + price numbers
// Installments and other price-container children stay in place.

function initTitlePriceLayout() {
  if (document.querySelector('.title-price-row')) return;

  const trustBadge = document.querySelector('[id^="trust-badge-"]');
  const title = document.querySelector('.title-row');
  const priceNumbers = document.querySelector('.product-info__price');

  if (!title || !priceNumbers) return;

// ── Judge.me Preview Badge ───────────────────────────────────────────────
  const judgeMe = document.querySelector(
    '.shopify-app-block:has(.jdgm-preview-badge)'
  );


  // Both trust badge and title must share the same parent for this to work
  const parent = title.parentNode;


  if (trustBadge && trustBadge.parentNode !== parent) return;


  // Outer flex wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'title-price-row';


  // Left column: Judge.me + trust badge + title
  const leftCol = document.createElement('div');
  leftCol.className = 'title-price-left';


  // Judge.me rating on top
  if (judgeMe) {
    leftCol.appendChild(judgeMe);
  }


  // Trust badge underneath Judge.me
  if (trustBadge) {
    leftCol.appendChild(trustBadge);
  }


  // Title underneath
  leftCol.appendChild(title);


  // Right column: SAVE badge (inserted by initSavingsBadge)
  // + price numbers
  const rightCol = document.createElement('div');
  rightCol.className = 'price-right-col';


  rightCol.appendChild(priceNumbers);


  // Insert wrapper where the first moved element was
  parent.insertBefore(wrapper, parent.firstChild);


  wrapper.appendChild(leftCol);
  wrapper.appendChild(rightCol);
}

// ── Savings badge ────────────────────────────────────────────────────────────

let savingsBadgeVariants = null;

async function loadSavingsVariants() {
  if (savingsBadgeVariants) return savingsBadgeVariants;

  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);

  if (!match) return null;

  try {
    const root = window.Shopify?.routes?.root || '/';

    const res = await fetch(
      `${root}products/${match[1]}.js`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!res.ok) return null;

    savingsBadgeVariants = (await res.json()).variants || [];

    return savingsBadgeVariants;

  } catch (e) {
    return null;
  }
}


function upsertSavingsBadge(compareAtPrice, price) {
  const container =
    document.querySelector('.price-right-col') ||
    document.querySelector('.price-container');

  if (!container) return;

  let badge = container.querySelector('.price__savings-badge');

  if (compareAtPrice > price) {

    const text = 'SAVE ' + formatMoney(compareAtPrice - price);

    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'price__savings-badge';

      container.insertBefore(
        badge,
        container.firstChild
      );
    }

    badge.textContent = text;
    badge.style.display = '';

  } else if (badge) {

    badge.style.display = 'none';

  }
}


async function initSavingsBadge() {
  if (!window.location.pathname.includes('/products/')) return;

  const variants = await loadSavingsVariants();

  if (!variants) return;

  function applyBadge(variantId) {

    const variant = variants.find(
      (v) => String(v.id) === String(variantId)
    );

    if (!variant) return;

    upsertSavingsBadge(
      priceToCents(variant.compare_at_price),
      priceToCents(variant.price)
    );
  }

  const initialInput = document.querySelector(
    'form[action*="/cart/add"] [name="id"], .js-variant-id'
  );

  if (initialInput) {
    applyBadge(initialInput.value);
  }

  document.addEventListener('variant:changed', (e) => {

    const id =
      e.detail?.variant?.id ||
      e.detail?.id;

    if (id) {
      applyBadge(id);
    }

  });

  let lastId = initialInput?.value;

  setInterval(() => {

    const input = document.querySelector(
      'form[action*="/cart/add"] [name="id"], .js-variant-id'
    );

    if (
      input &&
      input.value !== lastId
    ) {
      lastId = input.value;
      applyBadge(input.value);
    }

  }, 400);
}


// ── Initialize ───────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  initAutomaticRecommendations();
  initEmptyProducts();
  initTitlePriceLayout();
  initSavingsBadge();
});


document.addEventListener('on:cart:after-merge', () => {
  initAutomaticRecommendations();
  initEmptyProducts();
  openCartDrawerAfterRefresh();
});

})();